<template>
    <div>
        <navbar-header  page-name="Логистика"/>
        <OrdersDelivery class="body flex-grow-1"></OrdersDelivery>
    </div>
</template>

<script>
import NavbarHeader from '@/components/NavbarHeader'
import OrdersDelivery from '@/components/OrdersDelivery'
export default {
  name: 'OrdersDeliveryLayout',
  data () {
    return {
    }
  },
  components: {
    OrdersDelivery,
    NavbarHeader
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .navbar-text {
        padding: 0 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/OrdersDeliveryLayout.vue